import { LOCKED_CSS_PROPERTIES } from './brandPalette';

/**
 * Locked Sweet Listeners CSS variables for <html> and #page.
 * Hosted branding.json colors are ignored — Console teal/green must never win.
 *
 * @param {Object} [_brandingConfig] unused; kept so Page/app.js call sites stay stable
 * @returns {Object} custom CSS properties
 */
export const getCustomCSSPropertiesFromConfig = _brandingConfig => ({
  ...LOCKED_CSS_PROPERTIES,
});

/**
 * Write locked CSS properties onto a DOM element (usually documentElement).
 *
 * @param {Object} brandingConfig unused hosted branding
 * @param {Node} element DOM element
 */
export const includeCSSProperties = (brandingConfig, element) => {
  Object.entries(getCustomCSSPropertiesFromConfig(brandingConfig)).forEach(([key, value]) => {
    element.style.setProperty(key, value);
  });
};
